import React from "react";
import { Link } from "react-router-dom";
import style from "./DictionaryUsageLinks.module.scss";

export type IDictionaryUsageLink = {
  label: string;
  to?: string;
  href?: string;
  external?: boolean;
};

interface IDictionaryUsageLinksProps {
  links: IDictionaryUsageLink[];
  label?: string;
  className?: string;
  showColon?: boolean;
}

export const DictionaryUsageLinks = ({
  links,
  label = "Used in",
  className,
  showColon = true,
}: IDictionaryUsageLinksProps) => {
  if (!links.length) {
    return null;
  }

  const classes = [style.usage, className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      {label && (
        <span className={style.usageLabel}>
          {label}
          {showColon ? ":" : ""}
        </span>
      )}
      <span className={style.usageLinks}>
        {links.map((link, index) => {
          const key = `${link.to ?? link.href ?? link.label}-${index}`;
          const isExternal = !!link.href || link.external;
          return (
            <React.Fragment key={key}>
              {index > 0 && <span className={style.usageSeparator}>,</span>}
              {isExternal ? (
                <a
                  className={style.usageLink}
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {link.label}
                </a>
              ) : (
                <Link className={style.usageLink} to={link.to ?? ""}>
                  {link.label}
                </Link>
              )}
            </React.Fragment>
          );
        })}
      </span>
    </div>
  );
};
